export default "__VITE_ASSET__BvOvDH8W__"